import { useEffect } from 'react';
import { publishCallPresence, subscribeToCallPresence } from '@/lib/voip/callPresence';
import { hasCallInProgress, subscribeToCallWaitingTone, useVoipStore } from '@/stores/voip.store';

/**
 * Keeps this tab and its siblings in step.
 *
 * Telnyx rings every tab the user has open — they all register the same SIP
 * credential — but each tab's call map is its own, so the tab that isn't
 * handling the call would otherwise ring at full volume straight over it. This
 * publishes what this tab is doing and records what the others are doing, which
 * is what lets `ringModeOf` fall back to the quiet call-waiting beep.
 *
 * The call-waiting tone preference rides along for the same reason: the tab
 * that sounds the cue is often not the tab the CSR switched it off in.
 *
 * Mounted once, in the dashboard layout.
 */
export function useCallPresence(): void {
  const busy = useVoipStore((s) => hasCallInProgress(s.calls));

  useEffect(
    () =>
      subscribeToCallPresence((peerBusy) => {
        useVoipStore.setState({ _peerBusy: peerBusy }, false, 'voip/peerBusy');
      }),
    [],
  );

  useEffect(() => {
    publishCallPresence(busy);
  }, [busy]);

  useEffect(subscribeToCallWaitingTone, []);
}
